<template src="./template.html"></template>

<script>

import NavLink from '@/components/modules/DynamicLink/NavLink'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DynamicLink',
  components: {
    NavLink,
  },
  props: {
    'links': {
      type: String,
      required: true,
    },
    'navbarType': String,
    'urlLogin': String,
    'urlLogout': String,
    'urlWishlist': String,
    'urlBonusProgram': String,
    'urlProfile': String,
    'urlCancellation': String,
  },
  data() {
    return {
      dynamicLinks: [
        {
          id: 'wishlist',
          route: this.urlWishlist,
          label: 'top_nav.wishlist',
          is_protected: true,
          is_feature: true,
        },
        {
          id: 'profile',
          route: this.urlProfile,
          label: 'top_nav.account',
          is_protected: true,
          is_feature: false,
        },
        {
          id: 'bonus_program',
          route: this.urlBonusProgram,
          label: null,
          is_protected: true,
          is_feature: true,
          classes: [ 'bonus_program_coin' ],
        },
        {
          id: 'cancellation',
          route: this.urlCancellation,
          label: 'my_account.navi.cancellation',
          is_protected: true,
          is_feature: false,
        },
        {
          id: 'auth',
          route: null,
          label: null,
          is_protected: false,
          is_feature: false,
        },
      ],
      isDataFetched: false,
    }
  },
  computed: {
    ...mapState('auth', [
      'auth_status',
      'pendingAuth',
      'isInit',
    ]),
    ...mapState('translations', [ 'pendingTranslations' ]),
    ...mapState('settings', [
      'settings',
      'pendingSettings',
    ]),
    navItems() {
      return this.links ? JSON.parse(this.links) : []
    },
    navLinks() {
      const { isAuthenticated } = this.auth_status

      return this.dynamicLinks.filter(link => {
        if (!this.navItems.some(item => item === link.id) || (
          link.id === 'bonus_program' && !this.isBonusProgramActive
        )) {
          return false
        }

        if (!link.is_protected) return true

        return isAuthenticated && (
          !link.is_feature || this.hasFeature(link.id)
        )
      }).map(link => {
        if (link.id === 'auth') {
          return {
            ...link,
            route: !isAuthenticated ? this.urlLogin : this.urlLogout,
            label: !isAuthenticated ? 'my_account.login.log_in' : 'my_account.logout',
          }
        }

        if (link.id === 'bonus_program' && this.navbarType === 'top') {
          return { ...link, label: this.settings?.current_user?.bonus_points.toString() }
        }

        return link
      }).sort(this.compareNavLinks)
    },
    isBonusProgramActive() {
      return this.settings?.current_user?.bonus_program_member || this.hasFeature('use_virtual_currency')
    },
    isFetchComplete() {
      return Boolean(this.isDataFetched && !this.pendingTranslations)
    },
  },

  created() {
    const getAuthStatus = this.getAuthStatus()
    const getSettings = this.getSettings()

    Promise.all([
      getAuthStatus,
      getSettings,
    ]).then(() => {
      this.isDataFetched = true
    })
  },

  methods: {
    ...mapActions('auth', [ 'getAuthStatus' ]),
    ...mapActions('settings', [ 'getSettings' ]),

    /**
     *
     * @param feature
     * @returns {*}
     */
    hasFeature(feature) {
      const { active_features } = this.settings
      const feature_fallback = feature === 'bonus_program' ? 'use_virtual_currency' : feature
      return active_features ? active_features[feature] || active_features[feature_fallback] : true
    },

    /**
     *
     * @param link
     * @returns {*}
     */
    getLabel(link) {
      return this.dynamicLinks[link].label
    },
    compareNavLinks(a, b) {
      if (this.navItems.indexOf(a.id) < this.navItems.indexOf(b.id)) {
        return -1
      } else if (this.navItems.indexOf(a.id) > this.navItems.indexOf(b.id)) {
        return 1
      } else {
        return 0
      }
    },
  },

}
</script>
